export default "__VITE_ASSET__CptuWwfT__"